import { cruduex } from './utils';

import httpClient, { jsonObjectToFormData } from '@/utils/httpClient';

export default {
  namespaced: true,
  ...cruduex('visio', {
    async getById(id) {
      return httpClient.get(`/api/docs/visio/${id}`);
    },
    async getCollection() {
      return httpClient.get('/api/docs/visio/');
    },
    async create(data) {
      return httpClient.request('/api/docs/visio/', {
        json: false,
        method: 'POST',
        body: jsonObjectToFormData(data)
      });
    },
    async update(id, data) {
      return httpClient.request(`/api/docs/visio/${id}`, {
        json: false,
        method: 'PATCH',
        body: jsonObjectToFormData(data)
      });
    },
    async delete(id) {
      return httpClient.delete(`/api/docs/visio/${id}`);
    }
  })
};
